<template>
  <div class="cutThePrice" v-if="dataOyeLucky">
    <div class="toBeRefer" style="background: #e5f0e2;">
      <div class="img_wrpr">
        <img
          src="../../../assets/images/detail/oye-lucky.png"
          class="img_wrppr wdth100"
          alt="cut-the-price"
        />
      </div>
      <div class="share_link">
        <div class="prdt_hdng">{{$t('oyeLuckyOye')}}</div>
        <p class="cashback_txt">{{$t('shareThisLuckyItemMessage')}} </p>       
        <div class="customButtom" v-if="dataOyeLucky.itemMediaDTOList">
          <button
            type="button"
            class="white_btn"
            style="color: #6b93eb;"
            @click="shareFunc(dataOyeLucky.shareMessageUrl,dataOyeLucky.itemMediaDTOList[0].original, dataOyeLucky.saleReferenceID)"
          >{{$t("shareWithFrnds")}}</button>
        </div>
      </div>
    </div>
    <div class="bottomToUp" v-if="dataOyeLucky.displaymessage"></div>
    <div class="bottomToUp_content" :class="{'activeBottomtoUp' : dataOyeLucky.displaymessage}">
      <div class="popup_content">
        <span class="img_wrapper">
          <img src="../../../assets/images/detail/oye-lucky.png" alt="cut-the-price" />
        </span>
        <h5 class="prdt_hdng">{{$t('oyeLuckyOye')}}</h5>
      </div>
      <p class="refer_msg" v-if="dataOyeLucky.displaymessage">{{dataOyeLucky.displaymessage}}</p>

      <span class="closePopUp" @click="dataOyeLucky.displaymessage =!dataOyeLucky.displaymessage">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
          <path
            fill="#CDCDCD"
            fill-rule="nonzero"
            d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
            opacity=".675"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "OyeLuckyLuckyOye",
  props: {
    dataOyeLucky: {
      required: true,
      type: Object
    },
    colorBasedCutPrice: {
      type: Object
    }
  },
  data() {
    return {
      shareLinkData: {},
      // details: {},
      loading: false,
      isActiveBottomUp: false,
      isActivePopUp: false,
      cutPriceEnable: false,
      cutpricePersonList: {}
    };
  },
  methods: {
    shareFunc(shareMessage, shareImage, saleReferenceID) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        this.loading = true;
        this.$store
          .dispatch({ type: "getShareDetailsByItem", payload: saleReferenceID })
          .then(data => {
            this.shareLinkData = data.data;
            this.loading = false;
            shareMessage = data.data.shareMessage;
            const obj = {
              message: shareMessage,
              imageUrl: shareImage
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + shareMessage);
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = res => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
    cutPriceUserList(itemId) {
      this.isActivePopUp = true;
      this.availableCutPriceIndex = 0;
      this.$store
        .dispatch({
          type: "getCutPriceProductHistory",
          payload: itemId,
          itemId: this.availableCutPriceIndex
        })
        .then(data => {
          this.loading = false;
          this.cutpricePersonList = data.data;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>
    